<script lang="ts">
  import type { Token } from '@agapi/ui/panda/tokens';
  import { css, cx } from '@agapi/ui/panda/css';
  import { dynamicColorStyles, token } from '@agapi/ui/panda/utils';
  import { badge } from './badge.styles';
  import type { BadgeProps } from './badge.types';
  const { colorVariant = 'primary.subdued', size = 'md', rounded = 'full', outlined = false, style, css: cssProp, children, icon, iconPosition = "leading", ...props }: BadgeProps = $props();

  let withoutContent = $derived(children === undefined);
</script>

<div
  class={cx(
    badge({
      size,
      rounded,
      outlined,
      withoutContent
    }),
    css(cssProp)
  )}
  style="
    --bgColor: {dynamicColorStyles(colorVariant).backgroundColor};
    --fgColor: {dynamicColorStyles(colorVariant).color};
    --borderColor: {token(`colors.surface.${colorVariant}.border` as Token)};
    {style}
  "
>
  {#if icon && iconPosition == "leading"}
    {@render icon()}
  {/if}
  {@render children?.()}
  {#if icon && iconPosition == "trailing"}
    {@render icon()}
  {/if}
</div>
